import {
  createShift,
  getSessionMcodes,
  getShiftsList,
  getShiftById,
  deleteShift,
  getShiftByName,
  updateShift,
} from "@/http/system/shiftManagement.js";

export default {
  namespaced: true,
  state: {
    sessionList: [],
    shiftsList: [],
    shiftById: {},
    shiftByName: {},
  },
  actions: {
    async createShiftAction(_, payload) {
      try {
        const res = await createShift(payload);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async updateShiftAction(_, payload) {
      try {
        const res = await updateShift(payload.name, payload.data);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async deleteShiftAction(_, payload) {
      try {
        const res = await deleteShift(payload);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getShiftsListAction({ commit }, data) {
      try {
        const resp = await getShiftsList(data);
        commit("SET_SHIFTS_LIST", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getShiftByNameAction({ commit }, data) {
      try {
        const resp = await getShiftByName(data);
        commit("SET_SHIFTS_BY_NAME", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getShiftByIdAction({ commit }, data) {
      try {
        const resp = await getShiftById(data);
        commit("SET_SHIFTS_BY_ID", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getSessionMcodesAction({ commit }, data) {
      try {
        const resp = await getSessionMcodes(data);
        commit("SET_SESSION_LIST", resp.data);
        return resp;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  mutations: {
    SET_SESSION_LIST(state, payload) {
      state.sessionList = payload;
    },
    SET_SHIFTS_LIST(state, payload) {
      state.shiftsList = payload;
    },
    SET_SHIFTS_BY_ID(state, payload) {
      state.shiftById = payload;
    },
    SET_SHIFTS_BY_NAME(state, payload) {
      state.shiftByName = payload;
    },
  }
};
